import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = logged out

    useEffect(() => {
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => setUser(false));
    }, []);

    const login = useCallback(async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data);
        return data;
    }, []);

    const logout = useCallback(async () => {
        try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
        setUser(false);
    }, []);

    return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    return useContext(AuthContext);
}
